function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder_type_view") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,5.5H18.2L16.1,9.7H4.4V26.5H29.6V5.5Zm0,4.2H19.3l1.1-2.1h7.1Z",
    style: {
      fill: "#bf6d55"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.167 28.901 12.482 10 30.998 10 29.311 28.898 21.729 31 14.167 28.901",
    style: {
      fill: "#e44f26"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.74 29.393 27.867 27.694 29.309 11.545 21.74 11.545 21.74 29.393",
    style: {
      fill: "#f1662a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.99 24.011 14.99 20.404 14.99 19.097 20.99 15.489 20.99 17.512 17.162 19.75 20.99 21.989 20.99 24.011",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.49 24.009 22.49 21.988 26.345 19.75 22.49 17.513 22.49 15.491 28.49 19.082 28.49 20.418 22.49 24.009",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesClose);
export default __webpack_public_path__ + "static/media/pagesClose.f80b361dfd9d5a1e974783b3fa493283.svg";
export { ForwardRef as ReactComponent };